import { Box, TextField } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface FormInputProps {
  checked?: boolean;
}

export const LabelContainerStyled = styled(Box).attrs({
  py: { sm: '200' },
  pl: { sm: '450' },
  pr: { sm: '800' },
  alignItems: { sm: 'center' },
})<FormInputProps>`
  ${({ theme, checked }) => css`
    height: 30px;
    width: 160px;
    font-size: ${theme.fontSizes[400]};
    color: ${theme.colors.black};
    border-radius: ${theme.radii[200]} 0px 0px ${theme.radii[200]};
    border-right: 1px solid ${theme.colors.grey[300]};
    border-color: transparent;
    background-color: ${checked ? theme.colors.blue[200] : theme.colors.grey[200]};
  `}
`;

export const TextFieldStyled = styled(TextField)<FormInputProps>`
  ${({ theme, checked }) => css`
    border-radius: 0px ${theme.radii[200]} ${theme.radii[200]} 0px;
    background-color: ${({ theme }) => checked && theme.colors.blue[100]};
    border: 1px solid ${checked ? theme.colors.blue[300] : theme.colors.grey[300]};
    border-color: transparent;
    height: 30px;
    width: 308px;
     {
      /* TODO: make it to percentage of the container */
    }
    &:focus {
      border-color: transparent;
      box-shadow: none;
    }
  `}
`;

export const InputWrapperStyled = styled(Box)<FormInputProps>`
  ${({ theme, checked }) => css`
    border-radius: ${theme.radii[200]};
    border: 1px solid ${checked ? theme.colors.blue[500] : theme.colors.grey[300]};
    background-color: ${({ theme }) => checked && theme.colors.blue[100]};
  `}
`;
